/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOpportunityDto
 */
export interface CreateOpportunityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    expectedRevenue?: number;
    /**
     *
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    recurringRevenue?: number;
    /**
     *
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    recurringPlanId?: number | null;
    /**
     *
     * @type {string}
     * @memberof CreateOpportunityDto
     */
    typeOfSale?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityDto
     */
    salesFamily?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityDto
     */
    priority?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityDto
     */
    dateDeadline?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    partnerId: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    salesEngineer?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    crmBusinessProvider?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOpportunityDto
     */
    stageId?: number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateOpportunityDto
     */
    orderIds?: Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOpportunityDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the CreateOpportunityDto interface.
 */
export function instanceOfCreateOpportunityDto(value: object): value is CreateOpportunityDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    return true;
}

export function CreateOpportunityDtoFromJSON(json: any): CreateOpportunityDto {
    return CreateOpportunityDtoFromJSONTyped(json, false);
}

export function CreateOpportunityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOpportunityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'expectedRevenue': json['expected_revenue'] == null ? undefined : json['expected_revenue'],
        'recurringRevenue': json['recurring_revenue'] == null ? undefined : json['recurring_revenue'],
        'recurringPlanId': json['recurring_plan'] == null ? undefined : json['recurring_plan'],
        'typeOfSale': json['type_of_sale'] == null ? undefined : json['type_of_sale'],
        'salesFamily': json['sales_family'] == null ? undefined : json['sales_family'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dateDeadline': json['date_deadline'] == null ? undefined : json['date_deadline'],
        'userId': json['user_id'],
        'partnerId': json['partner_id'],
        'salesEngineer': json['sales_engineer'] == null ? undefined : json['sales_engineer'],
        'crmBusinessProvider': json['crm_business_provider'] == null ? undefined : json['crm_business_provider'],
        'stageId': json['stage_id'] == null ? undefined : json['stage_id'],
        'orderIds': json['order_ids'] == null ? undefined : json['order_ids'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateOpportunityDtoToJSON(json: any): CreateOpportunityDto {
    return CreateOpportunityDtoToJSONTyped(json, false);
}

export function CreateOpportunityDtoToJSONTyped(value?: CreateOpportunityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'expected_revenue': value['expectedRevenue'],
        'recurring_revenue': value['recurringRevenue'],
        'recurring_plan': value['recurringPlanId'],
        'type_of_sale': value['typeOfSale'],
        'sales_family': value['salesFamily'],
        'priority': value['priority'],
        'date_deadline': value['dateDeadline'],
        'user_id': value['userId'],
        'partner_id': value['partnerId'],
        'sales_engineer': value['salesEngineer'],
        'crm_business_provider': value['crmBusinessProvider'],
        'stage_id': value['stageId'],
        'order_ids': value['orderIds'],
        'description': value['description'],
    };
}

